import { Avatar, Box, Card, CardContent, Checkbox, CircularProgress, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import productService from "../../../services/productService";

const SelectProduct = ({ setSelectedProducts, selectedProducts, productId, productMainId, setSelectedVariantProducts, selectedVariantProducts }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = useSelector(state => state?.auth?.user?.accessToken?.token);
    const authUserId = useSelector(state => state?.auth?.user?.id);
    const getProducts = async () => {
        try {
            
            setLoading(true);
            const result = await productService.getSendProducts(productId, productMainId,token,authUserId);
            setProducts(result?.data || []);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Error fetching products:", error);
        }
        finally {
            setLoading(false);
        }
    }
//tümünü seç
const handleAllProductToggle = () => {
    const allSelected =
        selectedProducts.length === 1 && 
        selectedVariantProducts.length === variantProducts.length;
    if (allSelected) {
        setSelectedProducts([]);
        setSelectedVariantProducts([]);
    } else {
        setSelectedProducts([mainProduct]);
        setSelectedVariantProducts(variantProducts);
    }
};


    const handleProductToggle = (productDetail) => {
        setSelectedProducts(prev => {
            const isAlreadySelected = prev.some(p => p.id === productDetail.id);

            if (isAlreadySelected) {
                return prev.filter(p => p.id !== productDetail.id);
            }
            else {
                return [...prev, productDetail];
            }
        });
    };

    const handleVariantProductToggle = (productDetail) => {
        setSelectedVariantProducts((prev) => {
            const isAlreadySelected = prev.some((p) => p.id === productDetail.id);

            if (isAlreadySelected) {
                return prev.filter((p) => p.id !== productDetail.id);
            } else {
                return [...prev, productDetail];
            }
        });
    };
    const mainProduct = products.find(product => product.id === parseInt(productId));
    const variantProducts = products.filter(product =>
        product.id !== parseInt(productId) &&
        product.productMainId === productMainId
    );
    const imageUrlMainProduct =
        mainProduct?.productImages && mainProduct?.productImages?.length > 0
            ? mainProduct?.productImages[0]?.imageUrl
            : 'https://via.placeholder.com/50';


    useEffect(() => {
        getProducts();
    },
        [productId])

    
    return (
        <Box>
            {

                loading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100vh"
                        width="100%"
                    >
                        <CircularProgress />
                    </Box>
                ) :
                    mainProduct && (
                        <Card sx={{ mb: 2 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Ana Ürün
                                </Typography>
                                <List>
                                <ListItem>
    <Checkbox
        checked={selectedProducts.length === 1 && 
            selectedVariantProducts.length === variantProducts.length}
        onChange={handleAllProductToggle}
    />
    <Typography variant="body1">Tümünü seç</Typography>
</ListItem>
                                    <ListItem>
                                        <Checkbox
                                            checked={selectedProducts.some(p => p.id === mainProduct.id)}
                                            onChange={() => handleProductToggle(mainProduct)}
                                        />
                                        <Avatar
                                            src={imageUrlMainProduct}
                                            alt={mainProduct.title}
                                            variant="square"
                                            style={{ width: 50, height: 50, marginRight: 10 }}
                                        />
                                        <ListItemText
                                            primary={mainProduct.title}
                                            secondary={`Stok Kodu: ${mainProduct.stockCode}`}
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    )}

            {variantProducts?.length > 0 && (
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Varyantlar
                        </Typography>
                        <List>
                            {variantProducts.map((product) => (
                                <ListItem key={product.id}>
                                    <Checkbox
                                        checked={selectedVariantProducts.some((p) => p.id === product.id)}
                                       
                                        onChange={() => handleVariantProductToggle(product)}
                                    />
                                    <Avatar
                                        src={product?.productImages?.[0]?.imageUrl}
                                        alt={product?.title}
                                        variant="square"
                                        style={{ width: 50, height: 50, marginRight: 10 }}
                                    />
                                    <ListItemText
                                        primary={product.title}
                                        secondary={`Stok Kodu: ${product.stockCode}`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </CardContent>
                </Card>
            )}
        </Box>
    );
};

export default SelectProduct;